/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ProtoDocumentDetail from './ProtoDocumentDetail';

/**
 * The ProtoDocumentResponse model module.
 * @module model/ProtoDocumentResponse
 * @version 1.0.0
 */
class ProtoDocumentResponse {
    /**
     * Constructs a new <code>ProtoDocumentResponse</code>.
     * @alias module:model/ProtoDocumentResponse
     */
    constructor() { 
        
        ProtoDocumentResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProtoDocumentResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProtoDocumentResponse} obj Optional instance to populate.
     * @return {module:model/ProtoDocumentResponse} The populated <code>ProtoDocumentResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProtoDocumentResponse();

            if (data.hasOwnProperty('exemption_request')) {
                obj['exemption_request'] = ProtoDocumentDetail.constructFromObject(data['exemption_request']);
            }
            if (data.hasOwnProperty('work_life')) {
                obj['work_life'] = ProtoDocumentDetail.constructFromObject(data['work_life']);
            }
            if (data.hasOwnProperty('tasks')) {
                obj['tasks'] = ProtoDocumentDetail.constructFromObject(data['tasks']);
            }
            if (data.hasOwnProperty('affidavit')) {
                obj['affidavit'] = ProtoDocumentDetail.constructFromObject(data['affidavit']);
            }
            if (data.hasOwnProperty('economic_activity')) {
                obj['economic_activity'] = ProtoDocumentDetail.constructFromObject(data['economic_activity']);
            }
            if (data.hasOwnProperty('contribution')) {
                obj['contribution'] = ProtoDocumentDetail.constructFromObject(data['contribution']);
            }
            if (data.hasOwnProperty('fee')) {
                obj['fee'] = ProtoDocumentDetail.constructFromObject(data['fee']);
            }
            if (data.hasOwnProperty('model130')) {
                obj['model130'] = ProtoDocumentDetail.constructFromObject(data['model130']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/ProtoDocumentDetail} exemption_request
 */
ProtoDocumentResponse.prototype['exemption_request'] = undefined;

/**
 * @member {module:model/ProtoDocumentDetail} work_life
 */
ProtoDocumentResponse.prototype['work_life'] = undefined;

/**
 * @member {module:model/ProtoDocumentDetail} tasks
 */
ProtoDocumentResponse.prototype['tasks'] = undefined;

/**
 * @member {module:model/ProtoDocumentDetail} affidavit
 */
ProtoDocumentResponse.prototype['affidavit'] = undefined;

/**
 * @member {module:model/ProtoDocumentDetail} economic_activity
 */
ProtoDocumentResponse.prototype['economic_activity'] = undefined;

/**
 * @member {module:model/ProtoDocumentDetail} contribution
 */
ProtoDocumentResponse.prototype['contribution'] = undefined;

/**
 * @member {module:model/ProtoDocumentDetail} fee
 */
ProtoDocumentResponse.prototype['fee'] = undefined;

/**
 * @member {module:model/ProtoDocumentDetail} model130
 */
ProtoDocumentResponse.prototype['model130'] = undefined;






export default ProtoDocumentResponse;

